import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  accountNameHeader: {
    id: 'widgets.bank_statements.table.account_name',
    defaultMessage: 'Account',
    description: 'Header of column account name',
  },
  dateHeader: {
    id: 'widgets.bank_statements.table.date',
    defaultMessage: 'Date',
    description: 'Header of column date',
  },
  labelHeader: {
    id: 'widgets.bank_statements.table.label',
    defaultMessage: 'Label',
    description: 'Header of column label',
  },
  categoryHeader: {
    id: 'widgets.bank_statements.table.category',
    defaultMessage: 'Category',
    description: 'Header of column category',
  },
  typeHeader: {
    id: 'widgets.bank_statements.table.type',
    defaultMessage: 'Type',
    description: 'Header of type category',
  },
  amountHeader: {
    id: 'widgets.bank_statements.table.amount',
    defaultMessage: 'Amount',
    description: 'Header of column amount',
  },
  incomesFilter: {
    id: 'widgets.bank_statements.cash_flow_filter.incomes_filter',
    defaultMessage: 'Incomes',
    description: 'Label of the incomes filter',
  },
  everyIncomes: {
    id: 'widgets.bank_statements.cash_flow_filter.every_incomes',
    defaultMessage: 'Every incomes',
    description: 'First filter of the incomes filter',
  },
  expensesFilter: {
    id: 'widgets.bank_statements.cash_flow_filter.expenses_filter',
    defaultMessage: 'Expenses',
    description: 'Label of the expenses filter',
  },
  everyExpenses: {
    id: 'widgets.bank_statements.cash_flow_filter.every_expenses',
    defaultMessage: 'Every expenses',
    description: 'First filter of the expenses filter',
  },
  incidentsFilter: {
    id: 'widgets.bank_statements.cash_flow_filter.incidents_filter',
    defaultMessage: 'Incidents',
    description: 'Label of the incidents filter',
  },
  everyIncidents: {
    id: 'widgets.bank_statements.cash_flow_filter.every_incidents',
    defaultMessage: 'Every incidents',
    description: 'First filter of the incidents filter',
  },
  noCashFlow: {
    id: 'widgets.bank_statements.no_cash_flow',
    defaultMessage: 'Transactions older than 4 months cannot be modified.',
    description: 'Description for no cash flow tooltip',
  },
  notesPlaceholder: {
    id: 'widgets.bank_statements.notes_placeholder',
    defaultMessage: 'Add a note',
    description: 'Notes input placeholder',
  },
  unloadMessage: {
    id: 'widgets.bank_statements.unload_message',
    defaultMessage: 'Your note(s) will not be saved.',
    description: 'Message for closing tab or reloading page when note is in progress',
  },
});
